<div class="relative" lOutsideClick (outsideClick)="close()">
  <button
    type="button"
    class="h-10 px-4 rounded-full bg-lGray850 border border-lGray700 text-lWhite text-base flex items-center gap-2 hover:bg-lGray800 transition-colors"
    [class.ring-2]="isOpen"
    [class.ring-lPrimary]="isOpen"
    (click)="toggle()"
  >
    <span>{{ selectedLabel }}</span>
    <l-icon class="text-lWhite text-base transition-transform" [class.rotate-180]="isOpen">expand_more</l-icon>
  </button>

  @if (isOpen) {
    <div class="absolute right-0 top-11 z-30 min-w-44 rounded-xl bg-lGray900 border border-lGray700 shadow-panel py-2">
      @for (option of options; track option.value) {
        <button
          type="button"
          class="w-full text-left px-4 py-2 text-base transition-colors"
          [class.text-lWhite]="option.value === selectedValue"
          [class.bg-lGray850]="option.value === selectedValue"
          [class.text-lSecondary]="option.value !== selectedValue"
          [class.hover:bg-lGray850]="option.value !== selectedValue"
          (click)="select(option.value)"
        >
          {{ option.label }}
        </button>
      }
    </div>
  }
</div>
